import { forwardRef } from "react";
import Header from "../../../app/components/Header";
import MainNav from "../../../app/components/MainNav";
import ScrollHintMouse from "../../../app/components/ScrollHintMouse";
import Promo from "./Promo";

const Home = forwardRef(function Home(
  {
    loggedIn,
    onMenuClick,
    onLogout,
    onScrollHintClick,
    onSubsectionClick,
    isMenuOpen,
    menuId,
    onContactClick,
    heroUrl,
  },
  ref,
) {
  return (
    <section
      ref={ref}
      className="home section"
      data-testid="gallery-hero"
      id="home"
      style={{
        backgroundImage: `url(${heroUrl})`,
      }}
    >
      <Header className="header header_type_main-nav">
        <MainNav
          activeSection="photos"
          activeSubsection="explore"
          loggedIn={loggedIn}
          onLogout={onLogout}
          onMenuClick={onMenuClick}
          onSubsectionClick={onSubsectionClick}
          isMenuOpen={isMenuOpen}
          menuId={menuId}
          onContactClick={onContactClick}
        />
      </Header>
      <Promo />
      <ScrollHintMouse
        onClick={onScrollHintClick}
        ariaLabel="Scroll to photos"
      />
    </section>
  );
});

export default Home;
